import ReportsIndex from '@/views/Reports/ReportsIndex.vue';
import ScoringElementSummaryIndex from '@/views/Reports/ScoringElementSummaryIndex.vue';
import LeadDashboardIndex from '@/views/Reports/LeadDashboardIndex.vue';
import AffiliateReportIndex from '@/views/Reports/AffiliateReportIndex.vue';
import AdverseActionFailuresReport from '@/views/Reports/AdverseActionFailuresReport.vue';
import LoanProActivityReport from '@/views/Reports/LoanProActivityReport.vue';
import StatementsReport from '@/views/Reports/StatementsReport.vue';
import StatementsAuditReport from '@/views/Reports/StatementsAuditReport.vue';
import StatementLogsReport from '@/views/Reports/StatementLogsReport.vue';
import ComplianceReport from '@/views/Reports/ComplianceReport.vue';

export default [
  {
    path: 'reports',
    name: 'reports',
    component: ReportsIndex,
    meta: {
      title: 'Reports',
    },
    children: [
      {
        path: 'scoring-element-summary',
        name: 'scoring-element-summary',
        component: ScoringElementSummaryIndex,
        meta: {
          title: 'Scoring Element Summary Report',
          permission: 'view report::scoring-element-summary',
        },
      },
      {
        path: 'lead-dashboard',
        name: 'lead-dashboard',
        component: LeadDashboardIndex,
        meta: {
          title: 'Lead Dashboard Report',
          permission: 'view report::lead-dashboard-report',
        },
      },
      {
        path: 'affiliate-report',
        name: 'affiliate-report',
        component: AffiliateReportIndex,
        meta: {
          title: 'Affiliate Report',
          permission: 'view report::affiliate-report',
        },
      },
      {
        path: 'adverse-action-failures-report',
        name: 'adverse-action-failures-report',
        component: AdverseActionFailuresReport,
        meta: {
          title: 'Adverse Action Failures Report',
          permission: 'view report::adverse-action-failures-report',
        },
      },
      {
        path: 'loanpro-activity-report',
        name: 'loanpro-activity-report',
        component: LoanProActivityReport,
        meta: {
          title: 'LoanPro Activity Report Report',
          permission: 'view report::loan-pro-activity-report',
        },
      },
      {
        path: 'tickets-streams-report',
        name: 'tickets-streams-report',
        component: () => import(/* webpackChunkName: "leads" */ '@/views/Reports/TicketsStreamsReport.vue'),
        meta: {
          title: 'Tickets Streams Report',
          permission: 'view report::tickets-streams-report',
        },
      },
      {
        path: 'statements-report',
        name: 'statements-report',
        component: StatementsReport,
        meta: {
          title: 'Statements Report',
          permission: 'view report::statements-report',
        },
      },
      {
        path: 'statements-audit-report',
        name: 'statements-audit-report',
        component: StatementsAuditReport,
        meta: {
          title: 'Statements Audit Report',
          permission: 'view report::statements-report',
        },
      },
      {
        path: 'statement-logs-report',
        name: 'statement-logs-report',
        component: StatementLogsReport,
        meta: {
          title: 'Statement Logs Report',
          permission: 'view report::statement-logs-report',
        },
      },
      {
        path: 'compliance-report',
        name: 'compliance-report',
        component: ComplianceReport,
        meta: {
          title: 'Compliance Report',
          permission: 'view report::compliance',
        },
      },
    ],
  },
];
